// ─────────────────────────────────────────────────────────────────────────────
// Service worker registration.
//
// Production only, on purpose. A worker caching /static/** during `npm start`
// would serve yesterday's bundle against today's code and produce bugs that
// vanish on a hard refresh — the classic way PWA caching wastes a day of
// debugging. See public/service-worker.js for what is and isn't cached.
// ─────────────────────────────────────────────────────────────────────────────

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  // Registering before load would compete with the app's own first paint and
  // its initial API calls for bandwidth.
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL || ''}/service-worker.js`)
      .catch((err) => {
        // Never fatal: the app works fine uninstalled and un-cached.
        console.error('[pwa] service worker registration failed:', err);
      });
  });
}

/**
 * Removes any previously installed worker and its caches. Kept as the escape
 * hatch for the one failure mode that is genuinely hard for a user to get out
 * of — a bad worker pinning a broken build — since they cannot clear it from
 * the UI. Call it from the console, or wire it to a support action.
 */
export async function unregisterServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(registrations.map((r) => r.unregister()));
  if (window.caches) {
    const names = await caches.keys();
    await Promise.all(names.filter((n) => n.startsWith('dextream-')).map((n) => caches.delete(n)));
  }
}
